// https://github.com/csandman/chakra-react-select#chakrastyles
import { ChakraStylesConfig } from "chakra-react-select";

import { NAV_MENU_WIDTH, WORKSPACE_SELECT_HEIGHT } from "@/constants/sizes";

import selectStyles from "./selectStyles";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const workspaceSelectStyles: ChakraStylesConfig<any, any, any> = {
  valueContainer: (provided, state) => ({
    ...(selectStyles.valueContainer && selectStyles.valueContainer(provided, state)),
    bg: "background.base",
    height: WORKSPACE_SELECT_HEIGHT,
    px: 1,
    py: 0,
  }),
  control: (provided, state) => ({
    ...(selectStyles.control && selectStyles.control(provided, state)),
    border: "1px solid",
    borderColor: "border.darker",
    borderRadius: "md",
    height: WORKSPACE_SELECT_HEIGHT,
    minHeight: WORKSPACE_SELECT_HEIGHT,
    pl: 0,
    bg: "background.base",
    flexWrap: "nowrap",
  }),
  dropdownIndicator: (provided, state) => ({
    ...(selectStyles.dropdownIndicator && selectStyles.dropdownIndicator(provided, state)),
    paddingLeft: 2,
    bg: "background.base",
  }),
  downChevron: (provided, state) => {
    return {
      ...(selectStyles.downChevron && selectStyles.downChevron(provided, state)),
      color: "text.lighter",
    };
  },
  indicatorSeparator: (provided, state) => ({
    ...(selectStyles.indicatorSeparator && selectStyles.indicatorSeparator(provided, state)),
  }),
  menu: (provided, state) => ({
    ...(selectStyles.menu && selectStyles.menu(provided, state)),
    position: "fixed",
    top: "unset",
    width: NAV_MENU_WIDTH,
  }),
  noOptionsMessage: (provided, state) => ({
    ...(selectStyles.noOptionsMessage && selectStyles.noOptionsMessage(provided, state)),
  }),
  option: (provided, state) => ({
    ...(selectStyles.option && selectStyles.option(provided, state)),
  }),
};

export default workspaceSelectStyles;
